import get from 'hs-lodash/get';
import I18n from 'I18n';
import HighlightCard from '../HighlightCard/HighlightCard';
import CartHighlightActions from './CartHighlightActions';
import CartHighlightTitle from './CartHighlightTitle';
import CartHighlightDetails from './CartHighlightDetails';
import useCartHighlightProperties from '../../hooks/useCartHighlightProperties';
import { CART_HIGHLIGHT_CARD } from '../../constants/dataTestIds';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CartHighlight = ({
  objectId
}) => {
  const {
    data,
    loading,
    error
  } = useCartHighlightProperties(objectId);
  const errorMessage = error ? 'Something went wrong' : '';
  const title = get(data, ['properties', 'hs_cart_name', 'value']) || I18n.text('highlightCard.title.noTitle');
  const properties = get(data, ['properties']);
  return /*#__PURE__*/_jsxs(HighlightCard, {
    "data-test-id": CART_HIGHLIGHT_CARD,
    loading: loading,
    errorMessage: errorMessage,
    children: [/*#__PURE__*/_jsx(CartHighlightActions, {
      objectId: objectId
    }), /*#__PURE__*/_jsx(CartHighlightTitle, {
      title: title
    }), /*#__PURE__*/_jsx(CartHighlightDetails, {
      properties: properties
    })]
  });
};
export default CartHighlight;